import React from 'react'
import { IoCalendarOutline, IoFootballOutline, IoPulseOutline, IoNotificationsOutline, IoTrendingUpOutline, IoFlameOutline, IoAddOutline } from 'react-icons/io5'
import { useDashboard, type WidgetType } from '../../context/DashboardContext'

interface WidgetOption {
  type: WidgetType
  label: string
  description: string
  icon: React.ReactNode
}

const WIDGET_OPTIONS: WidgetOption[] = [
  {
    type: 'fixtures',
    label: "Today's Fixtures",
    description: 'Live and upcoming matches',
    icon: <IoCalendarOutline size={20} />,
  },
  {
    type: 'leagues',
    label: 'Top Leagues',
    description: 'Quick league navigation',
    icon: <IoFootballOutline size={20} />,
  },
  {
    type: 'dixon',
    label: 'D&C Top Picks',
    description: 'Highest value predictions',
    icon: <IoPulseOutline size={20} />,
  },
  {
    type: 'alerts',
    label: 'Strategy Alerts',
    description: 'Active strategy matches',
    icon: <IoNotificationsOutline size={20} />,
  },
  {
    type: 'highlights',
    label: 'Cards/Goals',
    description: 'Top predictions from hubs',
    icon: <IoTrendingUpOutline size={20} />,
  },
  {
    type: 'trending',
    label: 'Trending Teams',
    description: 'Hot teams right now',
    icon: <IoFlameOutline size={20} />,
  },
]

export function WidgetPalette() {
  const { widgets, addWidget } = useDashboard()

  const disabledWidgets = widgets.filter((w) => !w.enabled).map((w) => w.type)
  const availableWidgets = WIDGET_OPTIONS.filter((opt) =>
    disabledWidgets.includes(opt.type)
  )

  if (availableWidgets.length === 0) {
    return null
  }

  return (
    <div className="widget-palette">
      <div className="widget-palette-header">
        <IoAddOutline size={18} />
        <span>Add Widget</span>
      </div>
      <div className="widget-palette-items">
        {availableWidgets.map((option) => (
          <button
            key={option.type}
            className="widget-palette-item"
            onClick={() => addWidget(option.type)}
            title={option.description}
          >
            <span className="widget-palette-item-icon">{option.icon}</span>
            <span className="widget-palette-item-label">{option.label}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
